import styled, { css } from 'styled-components';

export interface IClearProps {
	clearHeight?: string;
	clearHeightMobile?: string;
	clearBefore?: string;
}

const ClearBefore = css`
	&::before {
		clear: both;
		content: ' ';
		display: table;
		width: 100%;
	}
`;

export const ClearDiv = styled.div.attrs<IClearProps, any>({ className: 'clear' })`
	${(props) => (props.clearBefore ? ClearBefore : null)};
	&::before {
		height: ${(props) => (props.clearBefore ? props.clearBefore : null)};
	}
	&::after {
		clear: both;
		content: ' ';
		display: table;
		width: 100%;
		height: ${(props) => (props.clearHeight ? props.clearHeight : '20px')};

		@media (max-width: 768px) {
			height: ${(props) => (props.clearHeightMobile ? props.clearHeightMobile : '0px')};
		}
	}
`;
ClearDiv.displayName = 'ClearDiv';
